module.exports = __webpack_public_path__ + "img/landing-page-background01.0a0cfc9c.png";